import {getCollection} from '@/lib/filters/filters.js';
import {MapService, Markers} from '@/services/MapService';

interface LocatedItem {
  id: string;
  location?: {latitude?: number; longitude?: number};
}

/**
 * Pans to a collection item's marker at the current zoom, then pings it if it is on the map. A Hidden marker is still
 * panned to, so the camera shows where the record is even when the filters leave it out.
 * @param item The collection's slim item, or `undefined` when the collection does not hold it.
 * @param collection The filter collection holding the item, which is also its marker collection.
 */
export const panToMarker = async (item: LocatedItem | undefined, collection: string): Promise<void> => {
  const latitude = item?.location?.latitude;
  const longitude = item?.location?.longitude;
  if (!item || latitude === undefined || longitude === undefined) return;
  await MapService.centerViewport({lat: latitude, lng: longitude});
  const isShown = getCollection(collection)?.getFilteredIds().has(item.id);
  if (isShown) {
    Markers.ping(collection, item.id);
  }
};
